import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import TransportPage from '../../views/TransportPage/';

class Destination extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			rcode : '',
			picdrop : '',
			stime : '',
			km : '',
			amt : '',
			_message : '',
			alertClass :'',
			rcod : [],
		   _redirect : false,
		    posts : [],
			modal: false,
			modal1: false,
			data : []
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onEditSubmit = this.onEditSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.toggle = this.toggle.bind(this);
		this.toggle1 = this.toggle1.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
	}
	
	toggle(){
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	toggle1(){
		this.setState({
		  modal1: !this.state.modal1
		});
	}
	
	onUpdate(dt){
		
		this.setState({
		  modal1: !this.state.modal1
		});
		this.state.id = dt;
		this.getdatabyid();
	}
	
	onClick(e){
		
		document.getElementById("desform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** set value to react select **/
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}
	
	onEditSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('transport/editdestination',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.toggle1();
				this.setState({
					_message:'Destination Updated Successfully!..',
					alertClass:'alert alert-success',
				});
				document.getElementById("desform").reset();
				this.getdata();
			}
			else{
				this.toggle1();
				this.setState({
					_message:'Already Added',
					alertClass:'alert alert-danger'
				});
				document.getElementById("desform").reset();
			}
		});
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('transport/adddestination',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.toggle();
				this.setState({
					_message:'Destination Added Successfully!..',
					alertClass:'alert alert-success',
				});
				document.getElementById("desform").reset();
				this.getdata();
			}
			else{
				this.toggle();
				this.setState({
					_message:'Already Added',
					alertClass:'alert alert-danger'
				});
				document.getElementById("desform").reset();
			}
		});
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getroutecode();
		this.getdata();
	}
	
	/** get Route **/
	getroutecode(){
		
		GetData('transport/getroute').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					rcod : responseJson
				});
			}
		});	  
	}	
	
	getdata(){
		$("#showLoader").show();
		GetData('transport/getdestination').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	getdatabyid(){
		$("#showLoader").show();
		GetData('transport/getdesibyid/'+this.state.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					rcode : res[0]['routecode'],
					picdrop : res[0]['pickanddrop'],
					stime : res[0]['stoptime'],
					km : res[0]['kilometre'],
					amt : res[0]['amount']
				});
			}
		});
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) {
				$("#showLoader").show();
			PostData('transport/deletedestination',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Destination Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Destination',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
  render() {
	  
	var rc = this.state.rcod;
	
    return (
		<div>
		  <TransportPage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="12">
					<Card>
						<CardHeader>
							<strong>Destination</strong>
							<span className="pull-right">
								<Button outline color="primary" onClick={this.toggle}>Add</Button>
							</span>
						</CardHeader>
						<CardBody>
						  <Row>
						  <Col md="12">
							<div className={this.state.alertClass}>
								{this.state._message}
							</div>
						  </Col>
						  <form action="" method="post" role="form" id="desform" encType="multipart/form-data" onSubmit={this.onSubmit} >
							<Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} id="adddes">
							  <ModalHeader toggle={this.toggle}>Select</ModalHeader>
							  <ModalBody>
								<Row>
								  <Col md="3">
									<FormGroup>
									  <Label htmlFor="name">Route <span className="text-danger">*</span></Label>
									</FormGroup>
								  </Col>
								  <Col md="9">
									<FormGroup>
									  <select name="rcode" onChange={this.onChange} className="form-control" required>
										<option value="">Select</option>
										{
											rc.map(function (item) {
												return <option value={item.id }>{item.startplace} - {item.stopplace}</option>;
											})
										}
									  </select>
									</FormGroup>
								  </Col>
								  <Col md="3">
									<FormGroup>
									  <Label htmlFor="name">Pick up & Drop <span className="text-danger">*</span></Label>
									</FormGroup>
								  </Col>
								  <Col md="9">
									<FormGroup>
									  <Input type="text" name="picdrop" required onChange={this.onChange} />
									</FormGroup>
								  </Col>
								  <Col md="3">
									<FormGroup>
									  <Label htmlFor="name">Stop Time </Label>
									</FormGroup>
								  </Col>
								  <Col md="9">
									<FormGroup>
									  <Input type="time" name="stime" required onChange={this.onChange} />
									</FormGroup>
								  </Col>
								  <Col md="3">
									<FormGroup>
									  <Label htmlFor="name">Kilometre </Label>
									</FormGroup>
								  </Col>
								  <Col md="9">
									<FormGroup>
									  <Input type="text" name="km" required onChange={this.onChange} />
									</FormGroup>
								  </Col>
								  <Col md="3">
									<FormGroup>
									  <Label htmlFor="name">Amount <span className="text-danger">*</span> (per month)</Label>
									</FormGroup>
								  </Col>
								  <Col md="9">
									<FormGroup>
									  <Input type="text" name="amt" required onChange={this.onChange} />
									</FormGroup>
								  </Col>
								</Row>
							  </ModalBody>
							  <ModalFooter>
								<Button type="submit" size="sm" color="primary" onClick={this.onSubmit}><i className="fa fa-dot-circle-o"></i> Add</Button>
							  </ModalFooter>
							</Modal>
							<Modal isOpen={this.state.modal1} toggle={this.toggle1} className={this.props.className} id="editdes">
							  <ModalHeader toggle={this.toggle1}>Select</ModalHeader>
							  <ModalBody>
								<Row>
								  <Col md="3">
									<FormGroup>
									  <Label htmlFor="name">Route <span className="text-danger">*</span></Label>
									</FormGroup>
								  </Col>
								  <Col md="9">
									<FormGroup>
									  <select name="rcode" onChange={this.onChange} className="form-control" required value={this.state.rcode}>
										<option value="">Select</option>
										{
											rc.map(function (item) {
												return <option value={item.id }>{item.startplace} - {item.stopplace}</option>;
											})
										}
									  </select>
									</FormGroup>
								  </Col>
								  <Col md="3">
									<FormGroup>
									  <Label htmlFor="name">Pick up & Drop <span className="text-danger">*</span></Label>
									</FormGroup>
								  </Col>
								  <Col md="9">
									<FormGroup>
									  <Input type="text" name="picdrop" required onChange={this.onChange} value={this.state.picdrop} />
									</FormGroup>
								  </Col>
								  <Col md="3">
									<FormGroup>
									  <Label htmlFor="name">Stop Time </Label>
									</FormGroup>
								  </Col>
								  <Col md="9">
									<FormGroup>
									  <Input type="time" name="stime" required onChange={this.onChange} value={this.state.stime} />
									</FormGroup>
								  </Col>
								  <Col md="3">
									<FormGroup>
									  <Label htmlFor="name">Kilometre </Label>
									</FormGroup>
								  </Col>
								  <Col md="9">
									<FormGroup>
									  <Input type="text" name="km" required onChange={this.onChange} value={this.state.km} />
									</FormGroup>
								  </Col>
								  <Col md="3">
									<FormGroup>
									  <Label htmlFor="name">Amount <span className="text-danger">*</span> (per month)</Label>
									</FormGroup>
								  </Col>
								  <Col md="9">
									<FormGroup>
									  <Input type="text" name="amt" required onChange={this.onChange} value={this.state.amt} />
									</FormGroup>
								  </Col>
								</Row>
							  </ModalBody>
							  <ModalFooter>
								<Button type="submit" size="sm" color="primary" onClick={this.onEditSubmit}><i className="fa fa-dot-circle-o"></i> Update</Button>
							  </ModalFooter>
							</Modal>
							</form>
							<Table responsive bordered>
								<thead>
									<tr>
										<th>S.No</th>
										<th width="100">Vehicle</th>
										<th>Route</th>
										<th>Destination</th>
										<th>Place</th>
										<th>Start Time</th>
										<th>Amount</th>
										<th width="50">Manage</th>
									</tr>
								</thead>
								<tbody>
									{this.state.posts.map((item,index) =>
									 
										<tr key = {item}>
											<td>{index+1}</td>
											<td>{item.vehicle}</td>
											<td>{item.rplace}</td>
											<td>{item.pickanddrop}</td>
											<td>{item.place}</td>
											<td>{item.stoptime}</td>
											<td>{item.amount}</td>
											<td>
												<button name="editsub" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
												&nbsp;&nbsp;
												<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
											</td>
										</tr>

									 )}
								</tbody>
							</Table>
						  </Row>
						</CardBody>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Destination;


// WEBPACK FOOTER //
// ./src/transport/Destination/Destination.js